import { LicenseTier } from 'Model/index.js'
import { parseTier } from 'Util/billing.js'

const orientationCSS = {
  topleft: 'absolute -top-1 -left-2',
  bottom: 'absolute -bottom-2 center',
  relative: 'relative'
}

type BadgeOrientation = 'topleft' | 'bottom' | 'relative'
type BadgeStyle = 'primary' | 'secondary' | 'success' | 'warning' | 'error'

const Badge = ({
  title,
  orientation = 'topleft',
  badgestyle = 'primary',
  color
}: {
  title: string
  orientation?: BadgeOrientation
  badgestyle?: BadgeStyle
  color?: string
}) => (
  <div
    style={color ? { color } : {}}
    className={`${orientationCSS[orientation]} badge badge-sm badge-${badgestyle} badge-outline text-[10px] font-medium`}
  >
    {title}
  </div>
)

export const LicenseBadge = ({ licenseTier, orientation }: { licenseTier: LicenseTier; orientation?: BadgeOrientation }) => {
  switch (licenseTier) {
    case LicenseTier.BETA:
      return <BetaBadge orientation={orientation} />
    case LicenseTier.INSIGHT:
      return <INSIGHTLicenseBadge orientation={orientation} />
    default:
      return <BASELicenseBadge orientation={orientation} />
  }
}

export const BASELicenseBadge = ({ orientation = 'topleft' }: { orientation?: BadgeOrientation }) => (
  <Badge title="BASE" orientation={orientation} badgestyle="secondary" />
)

export const INSIGHTLicenseBadge = ({ orientation = 'topleft' }: { orientation?: BadgeOrientation }) => (
  <Badge title="INSIGHT" color={'#70d1b8ff'} orientation={orientation} />
)

export const BetaBadge = ({ orientation = 'topleft' }: { orientation?: BadgeOrientation }) => (
  <Badge title="BETA" orientation={orientation} badgestyle="warning" />
)

export const SubscriptionBadge = ({ planId, orientation = 'topleft' }: { planId: string; orientation?: BadgeOrientation }) => {
  const tier = parseTier(planId)
  const label = tier.charAt(0).toUpperCase() + tier.slice(1)
  return <Badge title={label} orientation={orientation} badgestyle="success" />
}
